// extracted by mini-css-extract-plugin
export default {"button":"EIPCU4","disabled":"LXTtTh","withBorder":"FBejZ4","withBorderBottom":"X2UaWS","style-gold-50":"rjFTmT","style-black":"TlAW5d"};